import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserAttributes = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 541,
	height: 279,
	viewBox: "0 0 541 279",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#prefix__filter0_d_3278_50308)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M251.4 239.4v-7.2c0-3.819 1.517-7.482 4.218-10.182A14.397 14.397 0 01265.8 217.8h14.4c3.819 0 7.482 1.517 10.182 4.218A14.397 14.397 0 01294.6 232.2v7.2m-36-50.4c0 3.819 1.517 7.482 4.218 10.182a14.397 14.397 0 0020.364 0 14.397 14.397 0 000-20.364 14.397 14.397 0 00-20.364 0A14.397 14.397 0 00258.6 189z",
				stroke: "#4E60A1",
				strokeWidth: 7.2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#prefix__filter1_d_3278_50308)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 10,
					y: 8,
					width: 124.105,
					height: 53,
					rx: 8,
					fill: "#fff",
					shapeRendering: "crispEdges"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M46 30l-8-4.5-8 4.5m16 0v9l-8 4.5M46 30l-8 4.5m0 9L30 39v-9m8 13.5v-9M30 30l8 4.5",
					stroke: "#4E60A1",
					strokeWidth: 2,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M64.145 41.7c-1 0-1.867-.167-2.6-.5-.734-.333-1.3-.807-1.7-1.42-.387-.627-.587-1.36-.6-2.2h2.5c0 .6.213 1.073.64 1.42.44.333 1.033.5 1.78.5.72 0 1.28-.167 1.68-.5.413-.333.62-.793.62-1.38 0-.493-.147-.92-.44-1.28-.28-.373-.687-.627-1.22-.76l-1.68-.46c-1.147-.293-2.034-.82-2.66-1.58-.614-.76-.92-1.68-.92-2.76 0-.827.186-1.547.56-2.16.373-.613.9-1.087 1.58-1.42.693-.333 1.506-.5 2.44-.5 1.413 0 2.533.367 3.36 1.1.826.72 1.246 1.693 1.26 2.92h-2.5c0-.573-.187-1.02-.56-1.34-.374-.333-.9-.5-1.58-.5-.654 0-1.16.153-1.52.46-.36.307-.54.74-.54 1.3 0 .507.133.94.4 1.3.28.347.68.593 1.2.74l1.74.48c1.16.293 2.046.82 2.66 1.58.613.747.92 1.673.92 2.78 0 .827-.2 1.56-.6 2.2-.4.627-.96 1.113-1.68 1.46s-1.567.52-2.54.52zm13.152-.2c-1.053 0-1.88-.293-2.48-.88-.587-.587-.88-1.393-.88-2.42v-5.44h-2.98V30.5h2.98v-3.1h2.52v3.1h4.22v2.26h-4.22v5.44c0 .693.34 1.04 1.02 1.04h3v2.26h-3.18zm9.572.2c-1.133 0-2.027-.3-2.68-.9-.653-.6-.98-1.407-.98-2.42 0-1.08.36-1.913 1.08-2.5.72-.587 1.74-.88 3.06-.88h2.74v-.94c0-.533-.173-.947-.52-1.24-.347-.307-.82-.46-1.42-.46-.547 0-1 .12-1.36.36-.36.24-.573.567-.64.98h-2.44c.12-1.04.587-1.867 1.4-2.48s1.853-.92 3.12-.92c1.347 0 2.407.34 3.18 1.02.787.667 1.18 1.573 1.18 2.72v7.46h-2.42v-1.92h-.4l.4-.54c0 .813-.3 1.46-.9 1.94-.6.48-1.4.72-2.4.72zm.82-1.88c.707 0 1.28-.18 1.72-.54.453-.36.68-.827.68-1.4v-1.34h-2.7c-.507 0-.913.147-1.22.44-.307.293-.46.68-.46 1.16 0 .52.173.933.52 1.24.36.293.847.44 1.46.44zm13.592 1.68c-1.053 0-1.88-.293-2.48-.88-.586-.587-.88-1.393-.88-2.42v-5.44h-2.98V30.5h2.98v-3.1h2.52v3.1h4.22v2.26h-4.22v5.44c0 .693.34 1.04 1.02 1.04h3v2.26h-3.18zm10.812.2c-.933 0-1.746-.18-2.44-.54a4.008 4.008 0 01-1.62-1.5c-.373-.653-.56-1.413-.56-2.28v-2.76c0-.867.187-1.62.56-2.26a3.965 3.965 0 011.62-1.52c.694-.36 1.507-.54 2.44-.54.92 0 1.72.18 2.4.54.694.36 1.227.867 1.6 1.52.387.64.58 1.393.58 2.26v1.98h-6.78v.78c0 .773.187 1.36.56 1.76.374.387.927.58 1.66.58.56 0 1.014-.093 1.36-.28.347-.2.567-.487.66-.86h2.46c-.186.947-.693 1.707-1.52 2.28-.813.56-1.806.84-2.98.84zm2.16-6.5v-.6c0-.76-.18-1.34-.54-1.74-.36-.413-.9-.62-1.62-.62-.72 0-1.266.207-1.64.62-.373.413-.56 1-.56 1.76v.42l4.54-.04-.18.2z",
					fill: "#000"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#prefix__filter2_d_3278_50308)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 154.105,
					y: 8,
					width: 220.105,
					height: 53,
					rx: 8,
					fill: "#fff",
					shapeRendering: "crispEdges"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M190.105 30l-8-4.5-8 4.5m16 0v9l-8 4.5m8-13.5l-8 4.5m0 9l-8-4.5v-9m8 13.5v-9m-8-4.5l8 4.5",
					stroke: "#4E60A1",
					strokeWidth: 2,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M203.969 41.5V26.9h8.76v2.18h-6.3v3.8h5.6v2.16h-5.6v4.28h6.3v2.18h-8.76zm11.273 0v-11h2.04v1.48h.42l-.34.36c0-.613.173-1.107.52-1.48.346-.373.793-.56 1.34-.56.586 0 1.04.24 1.36.72.333.48.5 1.127.5 1.94l-.44-.98h.68l-.26.36c0-.613.173-1.107.52-1.48.346-.373.806-.56 1.38-.56.68 0 1.22.253 1.62.76.4.507.6 1.193.6 2.06v8.38h-2.2v-8.28c0-.36-.08-.64-.24-.84-.16-.213-.394-.32-.7-.32-.294 0-.527.1-.7.3-.16.2-.24.487-.24.86v8.28h-1.8v-8.28c0-.373-.08-.66-.24-.86-.16-.2-.394-.3-.7-.3-.307 0-.54.1-.7.3-.147.2-.22.487-.22.86v8.28h-2.2zm12.492 3.6V30.5h2.44v2.1h.56l-.56.58c0-.893.267-1.593.8-2.1.533-.52 1.253-.78 2.16-.78 1.107 0 1.993.38 2.66 1.14.667.76 1 1.78 1 3.06v2.98c0 .853-.153 1.6-.46 2.24a3.373 3.373 0 01-1.26 1.46c-.547.347-1.193.52-1.94.52-.907 0-1.627-.253-2.16-.76-.533-.52-.8-1.227-.8-2.12l.56.58h-.58l.08 2.62v3.08h-2.5zm4.52-5.56c.64 0 1.14-.187 1.5-.56.36-.373.54-.907.54-1.6v-2.76c0-.693-.18-1.227-.54-1.6-.36-.373-.86-.56-1.5-.56-.627 0-1.12.193-1.48.58-.36.373-.54.9-.54 1.58v2.76c0 .68.18 1.213.54 1.6.36.373.853.56 1.48.56zm13.612 1.96c-.72 0-1.353-.147-1.9-.44a3.223 3.223 0 01-1.26-1.24c-.307-.547-.46-1.173-.46-1.88v-8.78h-3.52V26.9h6.02v11.04c0 .4.113.72.34.96.24.227.56.34.96.34h3.32v2.26h-3.5zm10.312.18c-.933 0-1.746-.173-2.44-.52a4.038 4.038 0 01-1.6-1.5c-.373-.653-.56-1.42-.56-2.3v-2.72c0-.88.187-1.64.56-2.28a3.86 3.86 0 011.6-1.5c.694-.36 1.507-.54 2.44-.54.947 0 1.76.18 2.44.54.68.347 1.207.847 1.58 1.5.387.64.58 1.393.58 2.26v2.74c0 .88-.193 1.647-.58 2.3-.373.64-.9 1.14-1.58 1.5-.68.347-1.493.52-2.44.52zm0-2.18c.667 0 1.18-.18 1.54-.54.374-.373.56-.907.56-1.6v-2.72c0-.707-.186-1.24-.56-1.6-.36-.36-.873-.54-1.54-.54-.653 0-1.166.18-1.54.54-.373.36-.56.893-.56 1.6v2.72c0 .693.187 1.227.56 1.6.374.36.887.54 1.54.54zm9.312 5.6l1.54-4.2-4.1-10.4h2.74l2.04 5.62c.107.307.214.68.32 1.12.107.427.187.78.24 1.06.067-.28.154-.633.26-1.06.107-.44.214-.813.32-1.12l1.92-5.62h2.64l-5.3 14.6h-2.62zm14.693-3.4c-.934 0-1.747-.18-2.44-.54a3.995 3.995 0 01-1.62-1.5c-.374-.653-.56-1.413-.56-2.28v-2.76c0-.867.186-1.62.56-2.26a3.953 3.953 0 011.62-1.52c.693-.36 1.506-.54 2.44-.54.92 0 1.72.18 2.4.54.693.36 1.226.867 1.6 1.52.386.64.58 1.393.58 2.26v1.98h-6.78v.78c0 .773.186 1.36.56 1.76.373.387.926.58 1.66.58.56 0 1.013-.093 1.36-.28.346-.2.566-.487.66-.86h2.46c-.187.947-.694 1.707-1.52 2.28-.814.56-1.807.84-2.98.84zm2.16-6.5v-.6c0-.76-.18-1.34-.54-1.74-.36-.413-.9-.62-1.62-.62-.72 0-1.267.207-1.64.62-.374.413-.56 1-.56 1.76v.42l4.54-.04-.18.2zm9.832 6.5c-.934 0-1.747-.18-2.44-.54a3.995 3.995 0 01-1.62-1.5c-.374-.653-.56-1.413-.56-2.28v-2.76c0-.867.186-1.62.56-2.26a3.953 3.953 0 011.62-1.52c.693-.36 1.506-.54 2.44-.54.92 0 1.72.18 2.4.54.693.36 1.226.867 1.6 1.52.386.64.58 1.393.58 2.26v1.98h-6.78v.78c0 .773.186 1.36.56 1.76.373.387.926.58 1.66.58.56 0 1.013-.093 1.36-.28.346-.2.566-.487.66-.86h2.46c-.187.947-.694 1.707-1.52 2.28-.814.56-1.807.84-2.98.84zm2.16-6.5v-.6c0-.76-.18-1.34-.54-1.74-.36-.413-.9-.62-1.62-.62-.72 0-1.267.207-1.64.62-.374.413-.56 1-.56 1.76v.42l4.54-.04-.18.2zm20.544 6.3V29.22h-3.82V26.9h10.16v2.32h-3.82V41.5h-2.52zm10.572 3.6l1.54-4.2-4.1-10.4h2.74l2.04 5.62c.107.307.214.68.32 1.12.107.427.187.78.24 1.06.067-.28.154-.633.26-1.06.107-.44.214-.813.32-1.12l1.92-5.62h2.64l-5.3 14.6h-2.62zm10.213 0V30.5h2.44v2.1h.56l-.56.58c0-.893.266-1.593.8-2.1.533-.52 1.253-.78 2.16-.78 1.106 0 1.993.38 2.66 1.14.666.76 1 1.78 1 3.06v2.98c0 .853-.154 1.6-.46 2.24a3.386 3.386 0 01-1.26 1.46c-.547.347-1.194.52-1.94.52-.907 0-1.627-.253-2.16-.76-.534-.52-.8-1.227-.8-2.12l.56.58h-.58l.08 2.62v3.08h-2.5zm4.52-5.56c.64 0 1.14-.187 1.5-.56.36-.373.54-.907.54-1.6v-2.76c0-.693-.18-1.227-.54-1.6-.36-.373-.86-.56-1.5-.56-.627 0-1.12.193-1.48.58-.36.373-.54.9-.54 1.58v2.76c0 .68.18 1.213.54 1.6.36.373.853.56 1.48.56zm11.952 2.16c-.934 0-1.747-.18-2.44-.54a3.995 3.995 0 01-1.62-1.5c-.374-.653-.56-1.413-.56-2.28v-2.76c0-.867.186-1.62.56-2.26a3.953 3.953 0 011.62-1.52c.693-.36 1.506-.54 2.44-.54.92 0 1.72.18 2.4.54.693.36 1.226.867 1.6 1.52.386.64.58 1.393.58 2.26v1.98h-6.78v.78c0 .773.186 1.36.56 1.76.373.387.926.58 1.66.58.56 0 1.013-.093 1.36-.28.346-.2.566-.487.66-.86h2.46c-.187.947-.694 1.707-1.52 2.28-.814.56-1.807.84-2.98.84zm2.16-6.5v-.6c0-.76-.18-1.34-.54-1.74-.36-.413-.9-.62-1.62-.62-.72 0-1.267.207-1.64.62-.374.413-.56 1-.56 1.76v.42l4.54-.04-.18.2z",
					fill: "#000"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#prefix__filter3_d_3278_50308)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 394.209,
					y: 8,
					width: 136.105,
					height: 53,
					rx: 8,
					fill: "#fff",
					shapeRendering: "crispEdges"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M430.209 30l-8-4.5-8 4.5m16 0v9l-8 4.5m8-13.5l-8 4.5m0 9l-8-4.5v-9m8 13.5v-9m-8-4.5l8 4.5",
					stroke: "#4E60A1",
					strokeWidth: 2,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M443.834 41.5V26.9h4.62c.974 0 1.814.18 2.52.54.72.36 1.28.867 1.68 1.52.4.64.6 1.4.6 2.28 0 .96-.246 1.807-.74 2.54a3.907 3.907 0 01-1.96 1.56l2.9 6.16h-2.8l-2.54-5.8h-1.78v5.8h-2.5zm2.5-8h2.12c.707 0 1.26-.193 1.66-.58.4-.387.6-.92.6-1.6 0-.693-.2-1.233-.6-1.62-.4-.4-.953-.6-1.66-.6h-2.12v4.4zm13.992 8.2c-.933 0-1.746-.18-2.44-.54a4.008 4.008 0 01-1.62-1.5c-.373-.653-.56-1.413-.56-2.28v-2.76c0-.867.187-1.62.56-2.26a3.965 3.965 0 011.62-1.52c.694-.36 1.507-.54 2.44-.54.92 0 1.72.18 2.4.54.694.36 1.227.867 1.6 1.52.387.64.58 1.393.58 2.26v1.98h-6.78v.78c0 .773.187 1.36.56 1.76.374.387.927.58 1.66.58.56 0 1.014-.093 1.36-.28.347-.2.567-.487.66-.86h2.46c-.186.947-.693 1.707-1.52 2.28-.813.56-1.806.84-2.98.84zm2.16-6.5v-.6c0-.76-.18-1.34-.54-1.74-.36-.413-.9-.62-1.62-.62-.72 0-1.266.207-1.64.62-.373.413-.56 1-.56 1.76v.42l4.54-.04-.18.2zm6.853 9.9v-2.08h3.26c.56 0 .98-.14 1.26-.42.28-.267.42-.653.42-1.16v-.82l.04-2.06h-.54l.54-.54c0 .893-.267 1.593-.8 2.1-.52.493-1.227.74-2.12.74-1.12 0-2.014-.38-2.68-1.14-.654-.76-.98-1.787-.98-3.08V34.5c0-1.28.326-2.3.98-3.06.666-.76 1.56-1.14 2.68-1.14.893 0 1.6.253 2.12.76.533.493.8 1.187.8 2.08l-.54-.54h.54l-.06-2.1h2.5v11c0 1.107-.367 1.98-1.1 2.62-.734.653-1.74.98-3.02.98h-3.3zm2.9-6.4c.64 0 1.133-.187 1.48-.56.36-.387.54-.92.54-1.6v-1.92c0-.68-.18-1.207-.54-1.58-.347-.387-.84-.58-1.48-.58s-1.134.187-1.48.56c-.347.373-.52.907-.52 1.6v1.92c0 .693.173 1.227.52 1.6.346.373.84.56 1.48.56zm7.572 2.8v-2.28h3.84v-6.46h-3.34V30.5h5.74v8.72h3.4v2.28h-9.64zm4.84-12.84c-.507 0-.907-.127-1.2-.38-.294-.267-.44-.62-.44-1.06 0-.44.146-.787.44-1.04.293-.267.693-.4 1.2-.4.506 0 .906.133 1.2.4.293.253.44.6.44 1.04 0 .44-.147.793-.44 1.06-.294.253-.694.38-1.2.38zm11.632 13.02c-.933 0-1.747-.173-2.44-.52a4.038 4.038 0 01-1.6-1.5c-.373-.653-.56-1.42-.56-2.3v-2.72c0-.88.187-1.64.56-2.28a3.86 3.86 0 011.6-1.5c.693-.36 1.507-.54 2.44-.54.947 0 1.76.18 2.44.54.68.347 1.207.847 1.58 1.5.387.64.58 1.393.58 2.26v2.74c0 .88-.193 1.647-.58 2.3-.373.64-.9 1.14-1.58 1.5-.68.347-1.493.52-2.44.52zm0-2.18c.667 0 1.18-.18 1.54-.54.373-.373.56-.907.56-1.6v-2.72c0-.707-.187-1.24-.56-1.6-.36-.36-.873-.54-1.54-.54-.653 0-1.167.18-1.54.54-.373.36-.56.893-.56 1.6v2.72c0 .693.187 1.227.56 1.6.373.36.887.54 1.54.54zm7.532 2v-11h2.44v2.1h.68l-.68.58c0-.907.26-1.613.78-2.12.533-.507 1.26-.76 2.18-.76 1.08 0 1.94.36 2.58 1.08.653.72.98 1.687.98 2.9v7.22h-2.5v-6.96c0-.667-.173-1.18-.52-1.54-.347-.36-.833-.54-1.46-.54-.613 0-1.1.187-1.46.56-.347.373-.52.907-.52 1.6v6.88h-2.5z",
					fill: "#000"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#prefix__filter4_d_3278_50308)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 94.052,
					y: 81,
					width: 148.105,
					height: 53,
					rx: 8,
					fill: "#fff",
					shapeRendering: "crispEdges"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M130.052 103l-8-4.5-8 4.5m16 0v9l-8 4.5m8-13.5l-8 4.5m0 9l-8-4.5v-9m8 13.5v-9m-8-4.5l8 4.5",
					stroke: "#4E60A1",
					strokeWidth: 2,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M148.157 114.7c-1.427 0-2.547-.387-3.36-1.16-.8-.787-1.2-1.853-1.2-3.2V99.9h2.52v10.42c0 .693.173 1.233.52 1.62.347.387.853.58 1.52.58.653 0 1.153-.193 1.5-.58.36-.387.54-.927.54-1.62V99.9h2.52v10.44c0 1.347-.4 2.413-1.2 3.2-.8.773-1.92 1.16-3.36 1.16zm11.572-.02c-.84 0-1.573-.133-2.2-.4-.626-.267-1.12-.633-1.48-1.1-.346-.48-.533-1.04-.56-1.68h2.5c.027.347.194.627.5.84.32.213.734.32 1.24.32h.88c.614 0 1.074-.12 1.38-.36.307-.24.46-.567.46-.98 0-.387-.14-.687-.42-.9-.266-.227-.686-.373-1.26-.44l-1.36-.2c-1.253-.173-2.173-.507-2.76-1-.586-.493-.88-1.233-.88-2.22 0-1.027.347-1.82 1.04-2.38.694-.573 1.714-.86 3.06-.86h.76c1.227 0 2.207.273 2.94.82.734.547 1.127 1.28 1.18 2.2h-2.5c-.04-.293-.206-.533-.5-.72-.28-.187-.653-.28-1.12-.28h-.76c-.573 0-.993.107-1.26.32-.253.2-.38.5-.38.9 0 .373.114.653.34.84.227.173.594.3 1.1.38l1.42.2c1.307.187 2.267.54 2.88 1.06.627.507.94 1.26.94 2.26 0 1.067-.366 1.9-1.1 2.5-.72.587-1.786.88-3.2.88h-.88zm12.432.02c-.933 0-1.746-.18-2.44-.54a4.008 4.008 0 01-1.62-1.5c-.373-.653-.56-1.413-.56-2.28v-2.76c0-.867.187-1.62.56-2.26a3.967 3.967 0 011.62-1.52c.694-.36 1.507-.54 2.44-.54.92 0 1.72.18 2.4.54.694.36 1.227.867 1.6 1.52.387.64.58 1.393.58 2.26v1.98h-6.78v.78c0 .773.187 1.36.56 1.76.374.387.927.58 1.66.58.56 0 1.014-.093 1.36-.28.347-.2.567-.487.66-.86h2.46c-.186.947-.693 1.707-1.52 2.28-.813.56-1.806.84-2.98.84zm2.16-6.5v-.6c0-.76-.18-1.34-.54-1.74-.36-.413-.9-.62-1.62-.62-.72 0-1.266.207-1.64.62-.373.413-.56 1-.56 1.76v.42l4.54-.04-.18.2zm5.693 6.3v-11h2.36v2.1h.62l-.74 1.28c0-1.187.266-2.08.8-2.68.533-.6 1.32-.9 2.36-.9 1.186 0 2.12.367 2.8 1.1.68.733 1.02 1.747 1.02 3.04v.8h-2.62v-.62c0-.707-.187-1.253-.56-1.64-.36-.387-.86-.58-1.5-.58-.654 0-1.16.193-1.52.58-.347.387-.52.933-.52 1.64v6.88h-2.5zm23.904 0v-2.2h2.94v-10.2h-2.94v-2.2h8.4v2.2h-2.94v10.2h2.94v2.2h-8.4zm11.692 0V99.9h4.34c.987 0 1.84.187 2.56.56.734.373 1.3.9 1.7 1.58.4.68.6 1.487.6 2.42v5.46c0 .92-.2 1.727-.6 2.42a4.19 4.19 0 01-1.7 1.6c-.72.373-1.573.56-2.56.56h-4.34zm2.5-2.3h1.84c.72 0 1.294-.2 1.72-.6.427-.413.64-.973.64-1.68v-5.46c0-.693-.213-1.24-.64-1.64-.426-.413-1-.62-1.72-.62h-1.84v10z",
					fill: "#000"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#prefix__filter5_d_3278_50308)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 262.157,
					y: 81,
					width: 184.105,
					height: 53,
					rx: 8,
					fill: "#fff",
					shapeRendering: "crispEdges"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M298.157 103l-8-4.5-8 4.5m16 0v9l-8 4.5m8-13.5l-8 4.5m0 9l-8-4.5v-9m8 13.5v-9m-8-4.5l8 4.5",
					stroke: "#4E60A1",
					strokeWidth: 2,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M316.342 114.7c-.933 0-1.753-.173-2.46-.52a4.008 4.008 0 01-1.62-1.5c-.373-.653-.56-1.42-.56-2.3v-6.36c0-.893.187-1.66.56-2.3a3.876 3.876 0 011.62-1.48c.707-.36 1.527-.54 2.46-.54.947 0 1.76.18 2.44.54.693.347 1.233.84 1.62 1.48s.58 1.407.58 2.3h-2.52c0-.693-.187-1.22-.56-1.58-.36-.36-.88-.54-1.56-.54s-1.207.18-1.58.54c-.373.36-.56.88-.56 1.56v6.38c0 .68.187 1.207.56 1.58.373.36.9.54 1.58.54s1.2-.18 1.56-.54c.373-.373.56-.9.56-1.58h2.52c0 .867-.193 1.627-.58 2.28a3.967 3.967 0 01-1.62 1.52c-.68.347-1.493.52-2.44.52zm11.912-.02c-.933 0-1.747-.173-2.44-.52a4.038 4.038 0 01-1.6-1.5c-.373-.653-.56-1.42-.56-2.3v-2.72c0-.88.187-1.64.56-2.28a3.864 3.864 0 011.6-1.5c.693-.36 1.507-.54 2.44-.54.947 0 1.76.18 2.44.54.68.347 1.207.847 1.58 1.5.387.64.58 1.393.58 2.26v2.74c0 .88-.193 1.647-.58 2.3-.373.64-.9 1.14-1.58 1.5-.68.347-1.493.52-2.44.52zm0-2.18c.667 0 1.18-.18 1.54-.54.373-.373.56-.907.56-1.6v-2.72c0-.707-.187-1.24-.56-1.6-.36-.36-.873-.54-1.54-.54-.653 0-1.167.18-1.54.54-.373.36-.56.893-.56 1.6v2.72c0 .693.187 1.227.56 1.6.373.36.887.54 1.54.54zm7.032 2v-11h2.04v1.48h.42l-.34.36c0-.613.174-1.107.52-1.48.347-.373.794-.56 1.34-.56.587 0 1.04.24 1.36.72.334.48.5 1.127.5 1.94l-.44-.98h.68l-.26.36c0-.613.174-1.107.52-1.48.347-.373.807-.56 1.38-.56.68 0 1.22.253 1.62.76.4.507.6 1.193.6 2.06v8.38h-2.2v-8.28c0-.36-.08-.64-.24-.84-.16-.213-.393-.32-.7-.32-.293 0-.526.1-.7.3-.16.2-.24.487-.24.86v8.28h-1.8v-8.28c0-.373-.08-.66-.24-.86-.16-.2-.393-.3-.7-.3-.306 0-.54.1-.7.3-.146.2-.22.487-.22.86v8.28h-2.2zm12.492 3.6v-14.6h2.44v2.1h.56l-.56.58c0-.893.267-1.593.8-2.1.534-.52 1.254-.78 2.16-.78 1.107 0 1.994.38 2.66 1.14.667.76 1 1.78 1 3.06v2.98c0 .853-.153 1.6-.46 2.24a3.373 3.373 0 01-1.26 1.46c-.546.347-1.193.52-1.94.52-.906 0-1.626-.253-2.16-.76-.533-.52-.8-1.227-.8-2.12l.56.58h-.58l.08 2.62v3.08h-2.5zm4.52-5.56c.64 0 1.14-.187 1.5-.56.36-.373.54-.907.54-1.6v-2.76c0-.693-.18-1.227-.54-1.6-.36-.373-.86-.56-1.5-.56-.626 0-1.12.193-1.48.58-.36.373-.54.9-.54 1.58v2.76c0 .68.18 1.213.54 1.6.36.373.854.56 1.48.56zm10.713 2.16c-1.134 0-2.027-.3-2.68-.9-.654-.6-.98-1.407-.98-2.42 0-1.08.36-1.913 1.08-2.5.72-.587 1.74-.88 3.06-.88h2.74v-.94c0-.533-.174-.947-.52-1.24-.347-.307-.82-.46-1.42-.46-.547 0-1 .12-1.36.36-.36.24-.574.567-.64.98h-2.44c.12-1.04.586-1.867 1.4-2.48.813-.613 1.853-.92 3.12-.92 1.346 0 2.406.34 3.18 1.02.786.667 1.18 1.573 1.18 2.72v7.46h-2.42v-1.92h-.4l.4-.54c0 .813-.3 1.46-.9 1.94-.6.48-1.4.72-2.4.72zm.82-1.88c.706 0 1.28-.18 1.72-.54.453-.36.68-.827.68-1.4v-1.34h-2.7c-.507 0-.914.147-1.22.44-.307.293-.46.68-.46 1.16 0 .52.173.933.52 1.24.36.293.846.44 1.46.44zm7.932 1.68v-11h2.44v2.1h.68l-.68.58c0-.907.26-1.613.78-2.12.533-.507 1.26-.76 2.18-.76 1.08 0 1.94.36 2.58 1.08.653.72.98 1.687.98 2.9v7.22h-2.5v-6.96c0-.667-.174-1.18-.52-1.54-.347-.36-.834-.54-1.46-.54-.614 0-1.1.187-1.46.56-.347.373-.52.907-.52 1.6v6.88h-2.5zm13.772 3.6l1.54-4.2-4.1-10.4h2.74l2.04 5.62c.107.307.213.68.32 1.12.107.427.187.78.24 1.06.067-.28.153-.633.26-1.06.107-.44.213-.813.32-1.12l1.92-5.62h2.64l-5.3 14.6h-2.62zm22.464-3.6v-2.2h2.94v-10.2h-2.94v-2.2h8.4v2.2h-2.94v10.2h2.94v2.2h-8.4zm11.693 0V99.9h4.34c.986 0 1.84.187 2.56.56.733.373 1.3.9 1.7 1.58.4.68.6 1.487.6 2.42v5.46c0 .92-.2 1.727-.6 2.42-.4.68-.967 1.213-1.7 1.6-.72.373-1.574.56-2.56.56h-4.34zm2.5-2.3h1.84c.72 0 1.293-.2 1.72-.6.426-.413.64-.973.64-1.68v-5.46c0-.693-.214-1.24-.64-1.64-.427-.413-1-.62-1.72-.62h-1.84v10z",
					fill: "#000"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "prefix__filter0_d_3278_50308",
				x: 183.277,
				y: 120.822,
				width: 179.446,
				height: 179.446,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 3.545 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 8.862 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", { values: "0 0 0 0 0.0873 0 0 0 0 0.0658333 0 0 0 0 0.334167 0 0 0 0.08 0" }),
					/* @__PURE__ */ _jsx("feBlend", {
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_3278_50308"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "effect1_dropShadow_3278_50308",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "prefix__filter1_d_3278_50308",
				x: .025,
				y: .02,
				width: 144.055,
				height: 72.95,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1.995 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.988 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", { values: "0 0 0 0 0.0873 0 0 0 0 0.0658333 0 0 0 0 0.334167 0 0 0 0.08 0" }),
					/* @__PURE__ */ _jsx("feBlend", {
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_3278_50308"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "effect1_dropShadow_3278_50308",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "prefix__filter2_d_3278_50308",
				x: 144.13,
				y: .02,
				width: 240.055,
				height: 72.95,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1.995 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.988 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", { values: "0 0 0 0 0.0873 0 0 0 0 0.0658333 0 0 0 0 0.334167 0 0 0 0.08 0" }),
					/* @__PURE__ */ _jsx("feBlend", {
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_3278_50308"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "effect1_dropShadow_3278_50308",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "prefix__filter3_d_3278_50308",
				x: 384.234,
				y: .02,
				width: 156.055,
				height: 72.95,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1.995 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.988 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", { values: "0 0 0 0 0.0873 0 0 0 0 0.0658333 0 0 0 0 0.334167 0 0 0 0.08 0" }),
					/* @__PURE__ */ _jsx("feBlend", {
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_3278_50308"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "effect1_dropShadow_3278_50308",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "prefix__filter4_d_3278_50308",
				x: 84.077,
				y: 73.02,
				width: 168.055,
				height: 72.95,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1.995 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.988 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", { values: "0 0 0 0 0.0873 0 0 0 0 0.0658333 0 0 0 0 0.334167 0 0 0 0.08 0" }),
					/* @__PURE__ */ _jsx("feBlend", {
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_3278_50308"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "effect1_dropShadow_3278_50308",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "prefix__filter5_d_3278_50308",
				x: 252.182,
				y: 73.02,
				width: 204.055,
				height: 72.95,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1.995 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.988 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", { values: "0 0 0 0 0.0873 0 0 0 0 0.0658333 0 0 0 0 0.334167 0 0 0 0.08 0" }),
					/* @__PURE__ */ _jsx("feBlend", {
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_3278_50308"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "effect1_dropShadow_3278_50308",
						result: "shape"
					})
				]
			})
		] })
	]
});
export default SvgUserAttributes;
